module.exports = __webpack_public_path__ + "img/fi-korean-food-800x527.a7eb3cad.jpg";